import { useParams } from "react-router-dom";
import { EiaStocks, FloatingStorages, OtherStocks } from '.';

export const Storage = ({ type: initType }) => {
    const { type: path } = useParams()
    const type = initType || path
    return type === 'eia' ? <EiaStocks /> : type === 'other' ? <OtherStocks /> : <FloatingStorages />
}